import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './B2BBuyers.css';

const categories = [
  'Abrasives', 'Access Control', 'AGM Battery', 'Agriculture & Farming',
  'AIDC', 'Appliances and Utilities', 'Audio Video', 'Automotive',
  'Baby & Infant Care', 'Bakery, Restaurant & Industrial Kitchen Machinery',
  'Bearings & Power Transmission', 'Building Material', 'CCTV',
  'Changeover Switch', 'Chemical Reagents & Catalysts', 'Civil',
  'Cleaning & Housekeeping', 'Connector', 'Custom Manufacturing',
  'Cutting Tools & Machining', 'DIN Rail', 'Electric Vehicles',
  'Electrical', 'Electricals', 'Electronic Components',
  'Ethernet Switch', 'Fasteners', 'Fire Alarm', 'Food Processing Machinery',
  'Gardening & Landscaping', 'Hand Tools', 'Hardware', 'Health & Nutrition',
  'Heat Exchangers', 'Home Solution', 'Hose, Tube & Fittings', 'Hydraulics',
  'Industrial Plants & Machineries', 'Industry Automation', 'Intrusion Alarm',
  'IT & Electronics', 'Kitchen and Pantry Supplies', 'Lab Supplies',
  'LED & Lighting', 'Load Breaker Switch', 'Lugs', 'Marking Accessories',
  'Material Handling', 'Measurement & Testing', 'Medical Supplies',
  'Mounting Accessories', 'Musical Instruments', 'Office Furniture & Decor',
  'Office Stationery & Supplies', 'Oils & Lubricants',
  'Outdoor & Recreational Supplies', 'Packaging Containers',
  'Packaging Material & Supplies', 'Paints & Coatings', 'Pallets',
  'Personal Hygiene', 'Pipes', 'PLC', 'Plumbing & Bathroom Fittings',
  'Pneumatics', 'Power Monitoring Product', 'Power Products', 'Power Supply',
  'Power Tools', 'Pumps & Motors', 'Raw Materials', 'Relay', 'Relay Module',
  'Safety', 'Safety Goods', 'Seals & Gaskets', 'Security', 'Sensor',
  'Services', 'Signalling Module', 'Solar', 'Spare Parts',
  'Switching & Controlling Product', 'Tapes, Adhesives & Sealants',
  'Terminal Block', 'Terminal Block Accessories', 'Tools Hardware & Accessories',
  'Trays and Crates', 'USB Cable', 'Valves', 'Welding & Soldering',
];

interface RFQLead {
  id: number;
  image: string;
  category: string;
  brand: string;
  name: string;
  quantity: number;
  postedAgo: string;
}

const ALL_LEADS: RFQLead[] = [
  { id: 1, image: 'https://cdn.moglix.com/p/yK3ZHY5XuO91d.jpg', category: 'Appliances and Utilities/Induction Stoves', brand: 'HM', name: 'HM 1500W Metal Black Powder Coated Mini Hotplated Manual Induction Cooktop', quantity: 3, postedAgo: '7 hours ago' },
  { id: 2, image: 'https://cdn.moglix.com/p/1eZtlztRLRG1b.jpg', category: 'Appliances and Utilities/Induction Stoves', brand: 'Prolife', name: 'Prolife Ultimate 2000W Aluminium Black & Silver Induction Cooktop with 8 Cooking Mode', quantity: 10, postedAgo: '7 hours ago' },
  { id: 3, image: 'https://cdn.moglix.com/p/DkQBsMblXHaS0.jpg', category: 'Appliances and Utilities/Fans/Ceiling Fans', brand: 'Longway', name: 'Longway Zephyr 28W 400rpm White BEE 5 Star 3 Blade BLDC Anti Dust Decorative Ceiling Fan with Remote Control, Sweep: 1200 mm', quantity: 8, postedAgo: '7 hours ago' },
  { id: 4, image: 'https://cdn.moglix.com/p/mGpfeNn7TUJzn.jpg', category: 'Power Tools/Cordless Power Tools/Cordless Impact Wrenches', brand: 'XLNT', name: 'XLNT 0-2300rpm 21V 450Nm Alloy Steel Yellow & Black Cordless Impact Wrench with Batteries & Charger', quantity: 1, postedAgo: '7 hours ago' },
  { id: 5, image: 'https://cdn.moglix.com/p/xLpBGyKOAxqNx.jpg', category: 'Appliances and Utilities/Fans/Pedestal Fans', brand: 'Zokasa', name: 'Zokasa Rio Pro 50W 2400rpm 1 Star Black Anti-Dust Pedestal Fan, Sweep: 400 mm', quantity: 1, postedAgo: '1 day ago' },
  { id: 6, image: 'https://cdn.moglix.com/p/JOAGCHJYmGVRi.jpg', category: 'Appliances and Utilities/Induction Stoves', brand: 'Rezek', name: 'Rezek 2000W Plastic Black Infrared Induction Cooktop with Touch Control & Glass Panel', quantity: 5, postedAgo: '7 hours ago' },
  { id: 7, image: 'https://cdn.moglix.com/p/wvDlKCdm9jTBE.jpeg', category: 'Appliances and Utilities/Induction Stoves', brand: 'Longway', name: 'Longway Cruiser 2000W Black Induction Cooktop with Push Button', quantity: 3, postedAgo: '7 hours ago' },
  { id: 8, image: 'https://cdn.moglix.com/p/tdx39tZP1nWB5.jpg', category: 'Power Tools/Cordless Power Tools/Cordless Impact Drills', brand: 'XLNT', name: 'XLNT 28 Pcs 1350rpm 21V Yellow & Black Cordless Drill Machine Kit', quantity: 5, postedAgo: '13 hours ago' },
  { id: 9, image: 'https://cdn.moglix.com/p/OrabFKKF51sj7.jpg', category: 'Appliances and Utilities/Induction Stoves', brand: 'Spalin', name: 'Spalin A8 Chef Eco 2000W Black Induction Cooktop with Push Button & Touch Panel', quantity: 5, postedAgo: '13 hours ago' },
  { id: 10, image: 'https://cdn.moglix.com/p/Bpud03yTODSnL.jpg', category: 'Office Stationery & Supplies/Audio Visual Equipment/Speakers', brand: 'Bencley', name: 'Bencley T-160 COMPACT 15W Black Stereo Channel Wireless Bluetooth Speaker', quantity: 1, postedAgo: '7 hours ago' },
  { id: 11, image: 'https://cdn.moglix.com/p/mFV6F5XWgHSYl.jpg', category: 'Appliances and Utilities/Air Conditioners/Tower AC', brand: 'LLOYD', name: 'Lloyd 1 Ton Portable Air Conditioner, GLP12B01TP', quantity: 2, postedAgo: '1 day ago' },
  { id: 12, image: 'https://cdn.moglix.com/p/bF98ybEea1Q80.jpg', category: 'Appliances and Utilities/Industrial & Domestic Coolers/Air Coolers', brand: 'Crompton', name: 'Crompton 10L Air Cooler with 4-Way Air Deflection & High Density Honeycomb Pad', quantity: 5, postedAgo: '2 days ago' },
  { id: 13, image: 'https://cdn.moglix.com/p/GoyLwK5WUzgAl.jpg', category: 'IT & Electronics/Storage Devices/Solid State Drives', brand: 'WD', name: 'WD Green 240GB 2.5 inch Sata Internal SSD, WDS240G3G0A', quantity: 10, postedAgo: '7 hours ago' },
  { id: 14, image: 'https://cdn.moglix.com/p/PH60Vp1BtQXHH.jpg', category: 'Appliances and Utilities/Fans/Wall Fans', brand: 'Longway', name: 'Longway Speedy 12 50W ABS Black Energy Saving 3 Blade Wall Fan, Sweep: 300 mm', quantity: 2, postedAgo: '7 hours ago' },
  { id: 15, image: 'https://cdn.moglix.com/p/JE89tHv9PIjOJ.jpg', category: 'Appliances and Utilities/Induction Stoves', brand: 'Kapli', name: 'Kapli 2000W Aluminum Black Infrared Induction Cooktop', quantity: 1, postedAgo: '7 hours ago' },
  { id: 16, image: 'https://cdn.moglix.com/p/FMI9OVUoiZhyl.jpg', category: 'Appliances and Utilities/Induction Stoves', brand: 'INDO', name: 'Indo IC-2225 2000W ABS Plastic Induction Cooktop', quantity: 36, postedAgo: '7 hours ago' },
  { id: 17, image: 'https://cdn.moglix.com/p/kL8Avvlegi9ir.jpg', category: 'Electricals/Wires & Cables/House Wires', brand: 'Havells', name: 'Havells 0.75 Sqmm Green Life Line Plus Single Core HRFR PVC Copper Insulated Flexible Cables, 90 m', quantity: 14, postedAgo: '7 hours ago' },
  { id: 18, image: 'https://cdn.moglix.com/p/paMutU7NpqMWi.jpg', category: 'Appliances and Utilities/Induction Stoves', brand: 'Philips', name: 'Philips HD4928/01 Viva Collection 2100W Black Induction Cooker with 1 Year Warranty', quantity: 1, postedAgo: '7 hours ago' },
  { id: 19, image: 'https://cdn.moglix.com/p/KAv8FrR1bVv5T.jpg', category: 'IT & Electronics/DJ Instruments & Equipment/DJ Speakers', brand: 'Ahuja', name: 'Ahuja 200W Loud DJ Speaker, SRX-250DXM', quantity: 12, postedAgo: '6 days ago' },
  { id: 20, image: 'https://cdn.moglix.com/p/5TkeLIGPOTckk.jpg', category: 'Security/CCTV Cameras/Smart WiFi Cameras', brand: 'EZVIZ', name: 'EZVIZ H9C 3MP Dual-Lens PT Smart Wi-Fi Camera with 2-Way Talk, AI-Powered Human/Vehicle Detect', quantity: 5, postedAgo: '19 hours ago' },
  { id: 21, image: 'https://cdn.moglix.com/p/VoE0fxO9CTjO0.jpg', category: 'IT & Electronics/Mobiles/Smartphones', brand: 'Realme', name: 'Realme 9 6.4 inch 6GB RAM/128GB Storage AMOLED Display Meteor Black Smartphone', quantity: 3, postedAgo: '7 hours ago' },
  { id: 22, image: 'https://cdn.moglix.com/p/k2Dzpqb6ypemt.jpg', category: 'IT & Electronics/Mobiles/Smartphones', brand: 'Realme', name: 'Realme Narzo 50A 4GB/128GB 6.5 inch Oxygen Green Smart Phone', quantity: 1, postedAgo: '39 minutes ago' },
  { id: 23, image: 'https://cdn.moglix.com/p/gzf7TcZxu4QCx.jpeg', category: 'IT & Electronics/Mobiles/Smartphones', brand: 'Vivo', name: 'Vivo Y300 8GB/256GB 6.67 inch Display Phantom Purple Hybrid Dual SIM 5G Smartphone', quantity: 1, postedAgo: '13 hours ago' },
  { id: 24, image: 'https://cdn.moglix.com/p/hX9LZ58NAar25.jpg', category: 'IT & Electronics/Storage Devices/Hard Disks', brand: 'Consistent', name: 'Consistent 500GB Desktop Hard Disk, CT3500SC', quantity: 20, postedAgo: '13 hours ago' },
  { id: 25, image: 'https://cdn.moglix.com/p/YmEwC1caHhM2c.png', category: 'Safety/Safety Helmets', brand: 'Studds', name: 'Studds Bike Safety Helmet Model Name CREST ECO Colour RED', quantity: 1, postedAgo: '7 hours ago' },
  { id: 26, image: 'https://cdn.moglix.com/p/saQRhPQgkBoGf.jpg', category: 'Electric Vehicles/Electric Scooters', brand: 'Green', name: 'Green Sunny 25km/h 250W Blue Non RTO Electric Scooter 80KM Range in 1 Charge', quantity: 1, postedAgo: '5 days ago' },
  { id: 27, image: 'https://cdn.moglix.com/p/jclYn1jNErkhF.jpg', category: 'Appliances and Utilities/Induction Stoves', brand: 'Lifelong', name: 'Lifelong 2000W Black Infrared Induction Stove, LLIRC001', quantity: 60, postedAgo: '19 hours ago' },
  { id: 28, image: 'https://cdn.moglix.com/p/hgMSHmyMyEmDo.jpg', category: 'Appliances and Utilities/Air Conditioners/Tower AC', brand: 'Blue Star', name: 'Blue Star 1 Ton 2 Star Fixed Portable Copper White Tower AC, PC12DB', quantity: 1, postedAgo: '19 hours ago' },
  { id: 29, image: 'https://cdn.moglix.com/p/nO3tH9l0tBMZ5.jpg', category: 'IT & Electronics/Storage Devices/Solid State Drives', brand: 'Consistent', name: 'Consistent 128GB 2.5 inch Solid State Drive, CTSSD128S6', quantity: 30, postedAgo: '19 hours ago' },
  { id: 30, image: 'https://cdn.moglix.com/p/4WncYzck29l1m.jpg', category: 'Cleaning & Housekeeping/Cleaning Equipment/Pressure Washer', brand: 'Balwaan Krishi', name: 'Balwaan Krishi PW-350 1800W 120-150bar Pressure Washer', quantity: 1, postedAgo: '1 day ago' },
];

const PAGE_SIZE = 10;

const B2BBuyers: React.FC = () => {
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('');
  const [page, setPage] = useState(1);
  const [supplied, setSupplied] = useState<Set<number>>(new Set());

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const filtered = useMemo(() => {
    return ALL_LEADS.filter(lead => {
      const matchSearch = !search.trim() ||
        lead.name.toLowerCase().includes(search.toLowerCase()) ||
        lead.brand.toLowerCase().includes(search.toLowerCase()) ||
        lead.category.toLowerCase().includes(search.toLowerCase());
      const matchCat = !activeCategory ||
        lead.category.toLowerCase().includes(activeCategory.toLowerCase());
      return matchSearch && matchCat;
    });
  }, [search, activeCategory]);

  const visible = filtered.slice(0, page * PAGE_SIZE);
  const hasMore = visible.length < filtered.length;

  const handleSupply = (id: number) => {
    setSupplied(prev => new Set(prev).add(id));
  };

  return (
    <div className="b2b-page">

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="b2b-hero">
        <div className="b2b-hero-inner">
          <div className="b2b-hero-text">
            <h1>Find B2B Bulk Buyers to<br /><span>Grow Your Business</span></h1>
            <p>
              A one-stop marketplace for buyers and sellers to purchase and sell wholesale industrial goods.
              Sellers save time and money finding the best deals on bulk orders across 100+ categories.
            </p>
            <Link to="/contact" className="b2b-hero-cta">Post a Buying Requirement →</Link>
          </div>
          <div className="b2b-hero-box"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="m21 16-9 5-9-5V8l9-5 9 5v8Z"/><path d="M3.3 7.8 12 12l8.7-4.2"/><path d="M12 22V12"/></svg></div>
        </div>
      </div>

      {/* ── Stats Strip ─────────────────────────────────── */}
      <div className="b2b-stats">
        <div className="b2b-stats-inner">
          <div className="b2b-stat">
            <div className="b2b-stat-value">240+</div>
            <div className="b2b-stat-label">Deals closed past week</div>
          </div>
          <div className="b2b-stat">
            <div className="b2b-stat-value">₹50Cr+</div>
            <div className="b2b-stat-label">Potential business opportunity at Industrybull</div>
          </div>
          <div className="b2b-stat">
            <div className="b2b-stat-value">10K+</div>
            <div className="b2b-stat-label">Number of buying requests</div>
          </div>
        </div>
      </div>

      {/* ── Breadcrumb ──────────────────────────────────── */}
      <div className="b2b-breadcrumb">
        <Link to="/">Home</Link>
        <span>›</span>
        <span>Find B2B Bulk Buyers</span>
      </div>

      {/* ── Main ────────────────────────────────────────── */}
      <div className="b2b-main">

        {/* Sidebar */}
        <aside className="b2b-sidebar">
          <div className="b2b-sidebar-header">
            Category <span>({categories.length})</span>
          </div>
          <div className="b2b-cat-list">
            <div
              className={`b2b-cat-item ${activeCategory === '' ? 'active' : ''}`}
              onClick={() => { setActiveCategory(''); setPage(1); }}
            >
              All Categories
            </div>
            {categories.map((cat, i) => (
              <div
                key={i}
                className={`b2b-cat-item ${activeCategory === cat ? 'active' : ''}`}
                onClick={() => { setActiveCategory(cat); setPage(1); }}
              >
                {cat}
              </div>
            ))}
          </div>
        </aside>

        {/* Right */}
        <div className="b2b-right">
          {/* Search */}
          <div className="b2b-search-bar">
            <input
              type="text"
              placeholder="Search for category, brand, product..."
              value={search}
              onChange={e => { setSearch(e.target.value); setPage(1); }}
              id="b2b-search-input"
            />
            <button><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg></button>
          </div>

          {/* Leads header */}
          <div className="b2b-leads-header">
            Top Buying Leads <span>({filtered.length} RFQs)</span>
          </div>

          {/* RFQ Cards */}
          <div className="b2b-rfq-list">
            {visible.map(lead => (
              <div key={lead.id} className="b2b-rfq-card">
                <div className="b2b-rfq-img">
                  <img
                    src={lead.image}
                    alt={lead.name}
                    onError={e => {
                      (e.target as HTMLImageElement).style.display = 'none';
                      (e.target as HTMLImageElement).parentElement!.innerHTML = `<div style="width:100%;height:100%;background:#f3f4f6;display:flex;align-items:center;justify-content:center;color:#9ca3af"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg></div>`;
                    }}
                  />
                </div>
                <div className="b2b-rfq-body">
                  <div className="b2b-rfq-top">
                    <div className="b2b-rfq-meta">
                      <p className="b2b-rfq-category">{lead.category}</p>
                      <span className="b2b-rfq-brand">Brand: {lead.brand}</span>
                    </div>
                    <button
                      className="b2b-supply-btn"
                      onClick={() => handleSupply(lead.id)}
                      style={supplied.has(lead.id) ? { background: '#6B7280', cursor: 'default' } : {}}
                      disabled={supplied.has(lead.id)}
                    >
                      {supplied.has(lead.id) ? 'SUBMITTED' : 'I CAN SUPPLY'}
                    </button>
                  </div>
                  <p className="b2b-rfq-name">{lead.name}</p>
                  <div className="b2b-rfq-footer">
                    <span className="b2b-rfq-qty">Qty: {lead.quantity}</span>
                    <span className="b2b-rfq-time">Posted {lead.postedAgo}</span>
                  </div>
                </div>
              </div>
            ))}

            {filtered.length === 0 && (
              <div style={{ textAlign: 'center', padding: '60px', color: '#6B7280', fontSize: '16px' }}>
                No RFQs found for your search.
              </div>
            )}
          </div>

          {/* Load More */}
          {hasMore && (
            <div className="b2b-load-more">
              <button onClick={() => setPage(p => p + 1)}>LOAD MORE</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default B2BBuyers;
